import { OrderListFilters } from "../contexts/OrderListFilterContext";

const hasActiveFilters = ({
  isArchived,
  references,
  clinicCodes,
  doctors,
  providers,
  statuses,
  createdAt,
  deliveryDate,
  lastShippingDate,
}: OrderListFilters): boolean => {
  return (
    isArchived != null ||
    !!references?.length ||
    !!clinicCodes?.length ||
    !!doctors?.length ||
    !!providers?.length ||
    !!statuses?.length ||
    !!createdAt?.start ||
    !!createdAt?.end ||
    !!deliveryDate?.start ||
    !!deliveryDate?.end ||
    !!lastShippingDate?.start ||
    !!lastShippingDate?.end
  );
};

export default hasActiveFilters;
